import { useSelector } from 'react-redux';
import get from 'lodash/get';
import { useRouteMatch } from 'react-router-dom';
import { generateAdjustInviteQuery } from 'utils/adjust';
const channelSelector = (state) => get(state, 'config.location.query.channel');
const featureSelector = (state) => get(state, 'config.location.query.feature');
const campaignSelector = (state) => get(state, 'config.location.query.campaign');
const platformSelector = (state) => get(state, 'config.location.query.platform');
const sourceSelector = (state) => get(state, 'config.location.query.source');
const useTracking = () => {
    const route = useRouteMatch();
    const channel = useSelector(channelSelector) || get(route, 'params.channel', 'other');
    const platform = useSelector(platformSelector) || get(route, 'params.platform', 'unknown');
    const feature = useSelector(featureSelector) || get(route, 'params.feature');
    const campaign = useSelector(campaignSelector) || get(route, 'params.campaign');
    const source = useSelector(sourceSelector) || 'website';
    return { channel, platform, feature, campaign, source };
};
const configSelector = (state) => state.config;
const useInviteEssentials = (config) => {
    const { origin } = useSelector(configSelector);
    const tracking = useTracking();
    const { owner, deeplink_path, feature: custom_feature } = config;
    const adjustParams = {
        channel: tracking.channel,
        platform: tracking.platform,
        feature: custom_feature || tracking.feature,
        campaign: tracking.campaign,
        deeplink_path,
        inviterId: owner === null || owner === void 0 ? void 0 : owner.id,
        inviterName: owner === null || owner === void 0 ? void 0 : owner.fullname,
    };
    const adjustLink = generateAdjustInviteQuery(owner, adjustParams);
    const linkData = {
        linkQuery: { link: adjustLink },
        getCopyLink: () => adjustLink,
        getRedirectLink: () => adjustLink,
    };
    const buttonsRefs = [() => null, () => null, () => null, () => null];
    return { buttonsRefs, linkData, tracking, config: { origin } };
};
export { useInviteEssentials, useTracking };
